const defaultRoutes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  //登录
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/account/Login.vue"),
  },
  //直播登录
  {
    path: "/login/livespread",
    name: "LoginLive",
    component: () => import("../views/account/LoginLiveSpread.vue"),
  },
  //忘记密码
  {
    path: "/forget",
    name: "Forget",
    component: () => import("../views/account/ForgotPassword.vue"),
  },
  //注册
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/Register.vue"),
  },
  //商品
  {
    path: "/product",
    name: "ProductList",
    component: () => import("../views/mall/Index.vue"),
  },
  //自定商品
  {
    path: "/product/:id",
    name: "ProductDiyList",
    component: () => import("../views/mall/Index.vue"),
  },
  //兼容旧版专题学习链接
  {
    path: "/special",
    component: () => import("../views/mall/Topic.vue"),
    children: [
      {
        path: "course/:id",
        name: "OldCourseDetail",
        component: () => import("../components/mall/TopicCourse.vue"),
      },
    ],
  },
  //专题学习
  {
    path: "/topic",
    component: () => import("../views/mall/Topic.vue"),
    children: [
      {
        path: "list/:id",
        name: "Special",
        component: () => import("../components/mall/TopicList.vue"),
      },
      {
        path: "major/:id",
        name: "MajorDetail",
        component: () => import("../components/mall/TopicMajor.vue"),
      },
      {
        path: "course/:id",
        name: "CourseDetail",
        component: () => import("../components/mall/TopicDetail.vue"),
      },
      {
        path: "course/study/:cid",
        name: "CourseStudy",
        meta: {
          requiredAuth: true,
        },
        component: () => import("../components/mall/TopicCourse.vue"),
      },
    ],
  },
  {
    path: "/course/secret",
    name: "BeforeTransSecret",
    component: () => import("../components/mall/BeforeTrans.vue"),
  },
  {
    path: "/special/trial/:id",
    name: "Trial",
    component: () => import(`../views/mall/TopicTrial.vue`),
  },
  {
    path: "/topic/api/:cid",
    name: "CourseStudyApi",
    component: () => import(`../views/mall/TopicApiStudy.vue`),
  },
  {
    path: "/topic/courseware",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "",
        name: "CourseWare",
        component: () => import("../views/mall/TopicCourseWare.vue"),
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  //购买相关
  {
    path: "/buy",
    component: () => import("../views/Layout.vue"),
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: "",
        name: "BuyProduct",
        component: () => import("../views/mall/Buy.vue"),
      },
      {
        path: "payment",
        name: "Payment",
        component: () => import("../views/mall/BuyPayment.vue"),
      },
      {
        path: "union",
        name: "PaymentUnion",
        component: () => import("../views/mall/BuyPaymentUnion.vue"),
      },
      {
        path: "wx",
        name: "PaymentWx",
        component: () => import("../views/mall/BuyPaymentWx.vue"),
      },
      {
        path: "qrcode",
        name: "PaymentQrcode",
        component: () => import("../views/mall/BuyPaymentQrcode.vue"),
      },
      {
        path: "success",
        name: "PaymentSuccess",
        component: () => import("../views/mall/BuySuccess.vue"),
      },
    ],
  },
  //课程学习练习题相关
  {
    path: "/course",
    component: () => import("../views/Layout.vue"),
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: "videopractice/:id",
        name: "VideoPractice",
        component: () => import("../views/exercise/VideoPractice.vue"),
      },
      {
        path: "practice/:id",
        name: "Practice",
        component: () => import("../views/exercise/ChapterPractice.vue"),
      },
      {
        path: "simexam/:id",
        name: "SimExam",
        component: () => import("../views/exercise/SimExamPractice.vue"),
      },
      {
        path: "reviewvideo",
        name: "ReviewVideo",
        component: () => import("../views/exercise/ReviewVideo.vue"),
      },
      {
        path: "reviewpractice",
        name: "ReviewPractice",
        component: () => import("../views/exercise/ReviewPractice.vue"),
      },
      {
        path: "wrong/:id",
        name: "WrongBook",
        component: () => import("../views/exercise/WrongBook.vue"),
      },
      {
        path: "favexercise/:id",
        name: "FavExercise",
        component: () => import("../views/exercise/FavExercise.vue"),
      },
      {
        path: "favvideo/:id",
        name: "FavVideo",
        component: () => import("../views/exercise/FavVideo.vue"),
      },
      {
        path: "discuss/:id",
        name: "Discuss",
        component: () => import("../views/exercise/Discuss.vue"),
      },
    ],
  },
  //会员中心
  {
    path: "/member",
    component: () => import("../views/member/Member.vue"),
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: "",
        name: "MemberCenter",
        component: () => import("../views/member/CourseList.vue"),
      },
      {
        path: "answer",
        name: "Answer",
        component: () => import("../views/member/Answer.vue"),
      },
      {
        path: "answercourse",
        name: "AnswerCourse",
        component: () => import("../views/member/AnswerCourse.vue"),
      },
      {
        path: "answerlist",
        name: "AnswerList",
        component: () => import("../views/member/AnswerList.vue"),
      },
      {
        path: "question",
        name: "Question",
        component: () => import("../views/member/Question.vue"),
      },
      {
        path: "questiondetail",
        name: "QuestionDetail",
        component: () => import("../views/member/QuestionDetail.vue"),
      },
      {
        path: "order",
        name: "MemberOrder",
        component: () => import("../views/member/Order.vue"),
      },
      {
        path: "class",
        name: "Class",
        component: () => import("../views/member/Class.vue"),
      },
      {
        path: "classdetail/:id",
        name: "ClassDetail",
        component: () => import("../views/member/ClassDetail.vue"),
      },
      {
        path: "live",
        name: "Live",
        component: () => import("../views/member/Live.vue"),
      },
      {
        path: "signing",
        name: "Signing",
        component: () => import("../views/member/Signing.vue"),
      },
      {
        path: "integral",
        name: "Integral",
        component: () => import("../views/member/Integral.vue"),
      },
      {
        path: "account",
        name: "Account",
        component: () => import("../views/member/Account.vue"),
      },
      {
        path: "account/bindphone",
        name: "AccountBindPhone",
        component: () => import("../views/member/AccountBindPhone.vue"),
      },
      {
        path: "account/modifyphone",
        name: "AccountModifyPhone",
        component: () => import("../views/member/AccountModifyPhone.vue"),
      },
      {
        path: "message",
        name: "Message",
        component: () => import("../views/member/Message.vue"),
      },
      //下方为定制机构专有路由
      {
        path: "info",
        name: "StudentInfo",
        component: () => import("../views/member/StudentInfo.vue"),
      },
      {
        path: "plan",
        name: "StudyPlan",
        component: () => import("../views/member/StudyPlan.vue"),
      },
    ],
  },
  //教师
  {
    path: "/teacher",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "",
        name: "TeacherList",
        component: () => import("../views/teacher/TeacherList.vue"),
      },
      {
        path: "teacherdetail/:id",
        name: "TeacherDetail",
        component: () => import("../views/teacher/TeacherDetail.vue"),
      },
    ],
  },
  //新闻
  {
    path: "/news",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "topic",
        name: "NewsTopic",
        component: () => import("../views/news/Topic.vue"),
      },
      {
        path: "topic/:id",
        name: "NewsTopicParam",
        component: () => import("../views/news/Topic.vue"),
      },
      {
        path: "",
        name: "News",
        component: () => import("../views/news/NewsList.vue"),
      },
      {
        path: ":id",
        name: "NewsList",
        component: () => import("../views/news/NewsList.vue"),
      },
      {
        path: "detail/:id",
        name: "NewsDetail",
        component: () => import("../views/news/NewsDetail.vue"),
      },
    ],
  },
  //关于我们
  {
    path: "/about",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "",
        name: "About",
        component: () => import("../views/news/About.vue"),
      },
    ],
  },
  //直播
  {
    path: "/live",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "",
        name: "LiveList",
        meta: {
          //requiredAuth: true,
        },
        component: () => import("../views/live/List.vue"),
      },

      {
        path: "scene",
        name: "LiveScene",
        meta: {
          requiredAuth: false,
        },
        component: () => import("../views/live/Scene.vue"),
      },
      {
        path: "spread/:id", //用于推广的
        name: "LiveSpread",
        meta: {
          requiredAuth: false,
        },
        component: () => import("../views/live/Index.vue"),
      },
      {
        path: "replay/:id",
        name: "LiveReplay",
        meta: {
          requiredAuth: false,
        },
        component: () => import("../views/live/Replay.vue"),
      },
      {
        path: "end",
        name: "LiveEnd",
        component: () => import("../views/live/End.vue"),
      },
    ],
  },
  {
    path: "/live/index/:id",
    name: "LiveIndex",
    meta: {
      requiredAuth: false,
    },
    component: () => import("../views/live/Index.vue"),
  },
  {
    path: "/app",
    name: "AppDown",
    component: () => import("../views/AppDown.vue"),
  },
  //API
  {
    path: "/member/auth",
    name: "AuthCourse",
    component: () => import("../views/api/AuthCourse.vue"),
  },
  {
    path: "/api/auth",
    name: "AuthProduct",
    component: () => import("../views/api/AuthProduct.vue"),
  },
  //OEM考卷题目预览
  {
    path: "/exercise/preview",
    name: "ExercisePreview",
    component: () => import("../views/exercise/Preview.vue"),
  },
  {
    path: "*",
    name: "HttpNotFound",
    component: () => import("../views/404.vue"),
  },
];

export default defaultRoutes;
